export function skillsReducer (state = {skills: [], loading: true, error: null}, action) {
  switch (action.type) {
    case 'LOAD_SKILLS_START':
      return {
        ...state,
        loading: true,
        error: null
      }
    case 'LOAD_SKILLS_SUCCESS':
      return {
        ...state,
        loading: false,
        skills: action.payload
      }
    case 'LOAD_SKILLS_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
        skills: []
      }
    default:
      return state;
  }
}

export default skillsReducer;



// WEBPACK FOOTER //
// ./src/reducers/skills.js